export default function() {
  if( window.location.host.indexOf( 'localhost' ) !== -1 ) {
    return 'https://apistaging.iqiglobal.com/api/v1';
  } else if( window.location.host.indexOf( 'signstaging.iqiglobal.com' ) !== -1 ) {
    return 'https://apistaging.iqiglobal.com/api/v1';
  } else if( window.location.host.indexOf( 'sign.iqiglobal.com' ) !== -1 ) {
    return 'https://api.iqiglobal.com/api/v1';
  }
}